/**
 * Centralized regex patterns for the application
 * All regex patterns should be defined here for consistency and maintainability
 */

// Phone number patterns
export const phoneInputRegex = /^(?:\+45|0045)?\d{0,8}$/;
export const phoneValidatorRegex = /^(?:\+45|0045)?[0-9]{8}$/;

// Email pattern

export const emailRegex =
  // eslint-disable-next-line no-control-regex
  /^(?:[A-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0B\x0C\x0E-\x1F\x21\x23-\x5B\x5D-\x7F]|[\x01-\x09\x0B\x0C\x0E-\x7F])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]{2,}(?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0B\x0C\x0E-\x1F\x21-\x5A\x53-\x7F]|\\[\x01-\x09\x0B\x0C\x0E-\x7F])+)\])$/i;

// Danish validation patterns
export const cprRegex = /^\d{10}$/;
export const cvrRegex = /^\d{8}$/;
export const customerNumberRegex = /^K\d{7}$/;

// Partial input patterns (for progressive validation)
export const cprPartialRegex = /^[0-9]{0,10}$/;
export const cvrPartialRegex = /^[0-9]{0,8}$/;
export const customerNumberPartialRegex = /^(K?[0-9]{0,7}|K)$/;
export const digitsPartialRegex = /^[0-9]*$/;

// Digits pattern
export const digitsRegex = /^\d+$/;

// Name pattern (basic validation)
export const nameRegex = /^[a-zA-ZÀ-ÖØ-öø-ÿ' -]+$/;

// HTML processing patterns
export const htmlTagRegex = /<[^>]*>/g;
export const headlineRegex = /<h[1-6][^>]*>(.*?)<\/h[1-6]>/i;
export const headlineGlobalRegex = /<h[1-6][^>]*>.*?<\/h[1-6]>/gi;
